export default "__VITE_ASSET__jfsFv$SD__"